/**
 * @fileoverview POST handler for the "/app_settings/:app_group_id/quiet_hours/rules" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdQuietHoursRulesCacheKeys } from "./constants";
import type {
  PostAppSettingsAppGroupIdQuietHoursRulesProps,
  PostAppSettingsAppGroupIdQuietHoursRulesResult,
  WorkspaceQuietHoursRulesUpsertErrors,
} from "./types";

export const postAppSettingsAppGroupIdQuietHoursRules = reactQueryMutationAdapter(
  appSettingsAppGroupIdQuietHoursRulesCacheKeys,
  createMutationFetcherFunctionWithShadowError<WorkspaceQuietHoursRulesUpsertErrors>()(
    (
      props: PostAppSettingsAppGroupIdQuietHoursRulesProps
    ): Promise<PostAppSettingsAppGroupIdQuietHoursRulesResult> => {
      return fetch(
        `/app_settings/${props.appGroupId}/quiet_hours/rules`,
        "POST",
        { rules: props.rules },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
